// extracted by mini-css-extract-plugin
module.exports = {"FiltersTrigger":"styles_FiltersTrigger__ljf0I","icon":"styles_icon__TK0Mr"};